"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.iCreateWorksiteDiary = exports.iWorksiteDiary = exports._iWorksiteDiary = void 0;
const t = require("io-ts");
exports._iWorksiteDiary = t.intersection([
    t.interface({
        id: t.number,
        diary_uuid: t.string,
        project_uuid: t.string,
        usergroup_id: t.number,
        name: t.string
    }),
    t.partial({
        perm: t.number,
        site_number: t.union([t.null, t.string]),
        created_at: t.number,
        updated_at: t.number,
        folder_id: t.number,
        folder_uuid: t.string
    })
]);
const _iCreateWorksiteDiary = t.interface({
    usergroup_id: t.number,
    name: t.string,
    site_number: t.string,
    project_uuid: t.string,
    folder_id: t.number,
    folder_uuid: t.string
});
exports.iWorksiteDiary = t.clean(exports._iWorksiteDiary);
exports.iCreateWorksiteDiary = t.clean(_iCreateWorksiteDiary);
//# sourceMappingURL=worksiteDiary.js.map